import React from "react"
import { graphql } from "gatsby"
import Layout from "./../components/layout"
import Blogcards from "../components/blogs/Blogcards"
import BackgroundImage from "gatsby-background-image"
import CategorySelector from "../components/blogs/CategorySelector"
import { useState } from "react"

function BlogsPage({ data }) {
  const [showSelectors, setShowSelectors] = useState(false)
  const blogs = data.blogs.edges
  const bgImg = data.bgImg
  const totalCount = data.posts.totalCount
  return (
    <Layout>
      <BackgroundImage
        fluid={bgImg.childImageSharp.fluid}
        className="blogContainer"
      >
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 text-center mt-5">
              <h1 className="text-danger pt-4 display-3">Blogs</h1>
              <p className="noOfPosts">
                {totalCount} {totalCount === "1" ? "post" : "posts"}
              </p>
              <button
                disabled={showSelectors}
                onClick={() => setShowSelectors(true)}
                className="btn btn-secondary btn-sm my-3 mx-auto"
                style={{ width: "300px" }}
              >
                Select Category
              </button>
              <CategorySelector
                showSelectors={showSelectors}
                setShowSelectors={setShowSelectors}
              />
            </div>
            <div className="col-md-10 my-3 mx-auto">
              <div className="row text-center">
                {blogs.map(({ node }) => (
                  <Blogcards
                    key={node.id}
                    title={node.frontmatter.title}
                    blog={node.frontmatter.blog}
                    date={node.frontmatter.date}
                    thumbnail={node.frontmatter.thumbnail}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </BackgroundImage>
    </Layout>
  )
}

export default BlogsPage

export const containerQuery = graphql`
  query {
    blogs: allMarkdownRemark(
      filter: { frontmatter: { type: { eq: "blog" } } }
      sort: { fields: frontmatter___thumbnail, order: DESC }
    ) {
      edges {
        node {
          id
          frontmatter {
            title
            blog
            date
            thumbnail
          }
        }
      }
    }
    bgImg: file(relativePath: { eq: "bg/bg1.jpg" }) {
      id
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
    posts: allMarkdownRemark(
      filter: { frontmatter: { type: { eq: "blog" } } }
    ) {
      totalCount
    }
  }
`
